import { ApiTypes } from "types"

const AUTO_RANGE_MODE_ALIASES: readonly string[] = ["auto", "vacation"]

export const isAutoRangeMode = (modeAlias?: string | null): boolean =>
  !!modeAlias && AUTO_RANGE_MODE_ALIASES.includes(modeAlias.toLowerCase())

type RunningModeBuckets = ApiTypes.Res.MonitoringHistoricalDataBucket["filters#running_mode_count"]["buckets"]

export const getAutoRangeModeDocCount = (buckets: RunningModeBuckets): number =>
  buckets.auto.doc_count + buckets.vacation.doc_count
